import { Button } from "@octopusdeploy/design-system-components";
import type { InsightsReportResource } from "@octopusdeploy/octopus-server-client";
import { useAnalyticSimpleActionDispatch } from "~/analytics/Analytics";
interface Props {
    report: InsightsReportResource;
}
export function DownloadReportCsvButton({ report }: Props) {
    const dispatchAction = useAnalyticSimpleActionDispatch();
    const onClick = () => dispatchAction("Click Insights Report Download CSV");
    return <Button importance="quiet" href={`/api/${report.SpaceId}/insights/reports/${report.Id}/deployments/csv`} label="Download CSV" external onClick={onClick}/>;
}
